import { Location } from '@angular/common';
import { Component, Input, OnChanges, OnInit, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { State } from '@app/core/ngrx/reducers';
import { getState } from '@app/core/ngrx/utils/state';
import { FormService } from '@app/core/services/form/form.service';
import { LoadingService } from '@app/core/services/loading/loading.service';
import { PaymentService } from '@app/core/services/payment/payment.service';
import { ToolService } from '@app/core/services/tool/tool.service';
import { isLastMinute } from '@app/shared/utils/lastminute';
import { applicationSelectors, paymentSelectors, userSelectors } from '@core/ngrx/selectors';
import { ModalService } from '@core/services/modal/modal.service';
import { WarningService } from '@core/services/warning/warning.service';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { LoadingController, NavController } from '@ionic/angular';
import { select, Store } from '@ngrx/store';
import { isNil, regexTools } from '@shared/utils/index';
import { Angulartics2GoogleTagManager } from 'angulartics2';
import { from, Observable, of } from 'rxjs';
import { flatMap, tap } from 'rxjs/operators';
import { datadogRum } from '@datadog/browser-rum';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-payment-stripe-inputs',
    templateUrl: './payment-stripe-inputs.component.html',
    styleUrls: ['./payment-stripe-inputs.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule, FontAwesomeModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PaymentStripeInputsComponent implements OnInit {
    faExclamationCircle = faExclamationCircle;

    // @Input() application?: any;
    payment_form: FormGroup;
    isInsurance = false;
    paymentType = 'booking-payment';
    //
    @Input() application_id?: string;
    //
    user_id: string;

    constructor(
        private router: Router,
        private loadingController: LoadingController,
        public toolService: ToolService,
        private paymentService: PaymentService,
        private lct: Location,
        private modalService: ModalService,
        private angulartics2GoogleTagManager: Angulartics2GoogleTagManager,
        private store: Store<State>,
        private warning: WarningService,
        private formService: FormService,
        private navCtrl: NavController
    ) {
        this.formChanges();
    }

    content: any;
    price$: Observable<number> = of(89900);

    billing: any = {};
    payment: any = {
        coupon: {},
    };
    stripe: any;
    cardNumber: any;
    cardCvc: any;
    cardExpiry: any;
    showWireInformation: any;

    setUpSummary(): void {
        /* empty */
    }

    ngOnInit() {
        this.paymentService.stripeEnv().subscribe((response: any) => {
            // get stripe variables
            this.stripe = Stripe(response.key);
            const elements = this.stripe.elements();
            const elementStyles = {
                base: {
                    color: '#32325d',
                    fontFamily: 'Quicksand, Open Sans, Segoe UI, sans-serif',
                    fontSize: '16px',
                    textAlign: 'center',
                    fontSmoothing: 'antialiased',

                    ':focus': {
                        color: '#424770',
                    },

                    '::placeholder': {
                        color: '#9BACC8',
                    },

                    ':focus::placeholder': {
                        color: '#CFD7DF',
                    },
                },
                invalid: {
                    color: '#FA755A',
                    ':focus': {
                        color: '#FA755A',
                    },
                    '::placeholder': {
                        color: '#FFCCA5',
                    },
                },
            };

            const elementClasses = {
                focus: 'focus',
                empty: 'empty',
                invalid: 'invalid',
            };

            this.cardNumber = elements.create('cardNumber', {
                style: elementStyles,
                classes: elementClasses,
            });
            this.cardNumber.mount('#card-number');

            this.cardExpiry = elements.create('cardExpiry', {
                style: elementStyles,
                classes: elementClasses,
            });
            this.cardExpiry.mount('#card-expiry');

            this.cardCvc = elements.create('cardCvc', {
                style: elementStyles,
                classes: elementClasses,
            });
            this.cardCvc.mount('#card-cvc');

            this.cardNumber.addEventListener('change', (event: any) => {
                const displayError = document.getElementById('card-errors');
                displayError.textContent = event.error ? event.error.message : '';
            });

            this.cardExpiry.addEventListener('change', (event: any) => {
                const displayError = document.getElementById('card-errors');
                displayError.textContent = event.error ? event.error.message : '';
            });

            this.cardCvc.addEventListener('change', (event: any) => {
                const displayError = document.getElementById('card-errors');
                displayError.textContent = event.error ? event.error.message : '';
            });
        });

        // get user id when components loads
        this.store.select(userSelectors.getUserID).subscribe((id: string) => {
            this.user_id = id;
        });
    }

    formChanges() {
        this.paymentService.getPaymentForm().subscribe((form: FormGroup) => {
            this.payment_form = form;
        });
    }

    submit = (): void => {
        //
        this.payment.paying = true;
        //
        if (!this.payment_form) {
            this.warning.create('Please complete your billing information.');
            this.payment.paying = false;
        } else if (this.payment_form.invalid) {
            const result = this.formService.invalidFields(this.payment_form);
            const missingFields = result.map((field: any) => field.control).join(', ');
            this.warning.create(missingFields, 'Missing:');
            this.payment.paying = false;
        } else {
            this.creditCharge();
            // }
        }
    };

    creditCharge = () => {
        // set higher scope loader element
        let loading: HTMLIonLoadingElement;
        // get current state
        const LilState: any = getState(this.store);
        // start creating stripe client source
        from(
            this.loadingController.create({
                message: 'Do not refresh',
            })
        )
            .pipe(
                flatMap((loader: HTMLIonLoadingElement) => {
                    loading = loader;
                    return from(loading.present());
                }),
                flatMap((_null) => {
                    return from(this.createSrc());
                }),
                flatMap((result: any) => {
                    if (result.error) {
                        loading.dismiss();
                        this.payment.paying = false;
                        this.warning.create(result.error.message);
                        throw new Error(`${result.error.message}`);
                    } else {
                        const data = {
                            paymenttype: 'booking-payment',
                            userid: this.user_id, // LilState.payment.payableApplication[0].userid,
                            applicationid: this.application_id, // LilState.payment.payableApplication[0].id,
                            amount: 89900, // LilState.payment.checkoutPrice,
                            srcid: result.source.id,
                            name: this.payment_form.value.name,
                            email: this.payment_form.value.email,
                            address: this.payment_form.value.address_line1,
                            city: this.payment_form.value.address_city,
                            state: this.payment_form.value.address_state,
                            postal: this.payment_form.value.address_zip,
                            country: this.payment_form.value.country,
                        };
                        // rum action booking payment call
                        // datadogRum.addAction(
                        //     'user_bookingPayment_buttonClick_call',
                        //     {
                        //         userid: this.user_id,
                        //         applicationid: this.application_id,
                        //         name: this.payment_form.value.name,
                        //         email: this.payment_form.value.email,
                        //         address: this.payment_form.value.address_line1,
                        //         city: this.payment_form.value.address_city,
                        //         state: this.payment_form.value.address_state,
                        //         postal: this.payment_form.value.address_zip,
                        //         country: this.payment_form.value.country,
                        //     }
                        // );
                        //
                        return this.paymentService.bookingPayment(data);
                        //
                    }
                })
            )
            .subscribe(
                (response: any) => {
                    if (response.type === 'success') {
                        // rum action booking success
                        // datadogRum.addAction(
                        //     'user_bookingPayment_buttonClick_success',
                        //     {
                        //         userid: this.user_id,
                        //         applicationid: this.application_id,
                        //         name: this.payment_form.value.name,
                        //         email: this.payment_form.value.email,
                        //         address: this.payment_form.value.address_line1,
                        //         city: this.payment_form.value.address_city,
                        //         state: this.payment_form.value.address_state,
                        //         postal: this.payment_form.value.address_zip,
                        //         country: this.payment_form.value.country,
                        //     }
                        // );
                        //
                        loading.dismiss();
                        //
                        this.angulartics2GoogleTagManager.pushLayer({
                            cdEmail: this.payment_form.value.email,
                        });
                        this.angulartics2GoogleTagManager.pageTrack('/applicationreservationpayment');
                        this.angulartics2GoogleTagManager.eventTrack('ApplicationReservationPayment', { category: 'Payment' });

                        this.modalService
                            .successfulPayment('booking')
                            .then((done: any) => {
                                let url = this.router.createUrlTree([`/application/${this.application_id}`]).toString();
                                this.lct.replaceState(url);
                                this.lct.go(url);
                                this.navCtrl.navigateForward([url]);
                            })
                            .catch((err: Error) => {
                                let url = this.router.createUrlTree([`/dashboard`]).toString();
                                this.lct.replaceState(url);
                                this.lct.go(url);
                                this.navCtrl.navigateForward([url]);
                            });
                    } else {
                        loading.dismiss();
                        // datadogRum.addAction(
                        //     'user_bookingPayment_buttonClick_failed',
                        //     {
                        //         userid: this.user_id,
                        //         applicationid: this.application_id,
                        //         name: this.payment_form.value.name,
                        //         email: this.payment_form.value.email,
                        //         address: this.payment_form.value.address_line1,
                        //         city: this.payment_form.value.address_city,
                        //         state: this.payment_form.value.address_state,
                        //         postal: this.payment_form.value.address_zip,
                        //         country: this.payment_form.value.country,
                        //     }
                        // );
                        this.payment.paying = false;
                        /* eslint-disable */
                        let message = `${response.message}<br><p>If you are having issues with making a payment, you contact us at <a href="mailto:'advisors@amopportunities.org'">advisors@amopportunities.org</a>.</p>`;
                        this.warning.create(message);
                    }
                },
                (err: Error) => {
                    loading.dismiss();
                    this.payment.paying = false;
                    console.log('error trying to submit payment: ', err);
                }
            );
    };

    createSrc(): Promise<any> {
        try {
            //
            return this.stripe.createSource(this.cardNumber, {
                owner: {
                    name: this.payment_form.value.name,
                    email: this.payment_form.value.email,
                    address: {
                        line1: this.payment_form.value.address_line1,
                        line2: null,
                        city: this.payment_form.value.address_city,
                        state: this.payment_form.value.address_state,
                        postal_code: this.payment_form.value.address_zip,
                        country: this.payment_form.value.country,
                    },
                },
            });
        } catch (e) {
            this.warning.create('Please enter your billing information');
            return new Promise((resolve) => resolve([]));
        }
    }
}
